import { Avatar, Box, Button, Divider, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import { Image, Tag } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { BsTextIndentLeft, BsTextIndentRight } from 'react-icons/bs';
import { FaUserCircle } from 'react-icons/fa';
import { Outlet, useLocation } from 'react-router-dom';
import { AWS_CONFIG_TYPE } from '../../BaseUrl';
import large_icon from '../../assets/images/large_icon.png';
import small_icon from '../../assets/images/small_icon.png';
import { AuthContext } from '../../context/AuthProvider';
import { menuItem, menuItemV1 } from '../../data/SidebarMenuItem';
import AWS_LOGO from '../../images/logoAWS.png';
import AZURE_LOGO from '../../images/logoAzure.png';
import AddConnectionModal from '../chat_gpt/AddConnectionModal';
import UploadModal from '../chat_gpt/UploadModal';
import SideBarLevel from './SideBarLevel';
import SideBarSubMenu from './SideBarSubMenu';
import './sidebar.css';
import { MAIN } from '../../utils/commonConstants';

const settings = ['Logout'];

const Sidebar = ({ title }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleIcon = () => setIsOpen(!isOpen);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const processType = queryParams.get('processType');

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openConnectionModal, setOpenConnectionModal] = useState(false);
  const { logoutUser } = useContext(AuthContext);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    logoutUser();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenAddNewConnectionModal = () => {
    setOpenConnectionModal(true);
  };

  const handleCloseAddNewConnectionModal = () => {
    setOpenConnectionModal(false);
  };

  const version = JSON.parse(sessionStorage.getItem('version'));

  const handleMenuItem = () => {
    if (version === '2.0') {
      return menuItem.map((item, index) => <SideBarLevel item={item} key={index} isOpen={isOpen} />);
    }
    return menuItemV1.map((item, index) => <SideBarSubMenu item={item} key={index} isOpen={isOpen} />);
  };

  const renderMenuItem = handleMenuItem();

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    if (windowSize.width < 769) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ width: isOpen ? '240px' : '60px' }} className="sidebar">
        <div
          className="top-section"
          style={{
            padding: isOpen ? '20px 30px 10px 15px' : ' 20px 10px',
            position: 'fixed',
            zIndex: 9999,
            backgroundColor: '#00043C',
            width: isOpen ? '220px' : '50px',
          }}
        >
          <div className="logo">
            {isOpen ? <img src={large_icon} alt="logo" width="100" /> : <img src={small_icon} alt="logo" width="30" />}
          </div>
        </div>
        <div className="sidebar-menu-block">
          <div className="sidebar-menu-content">{renderMenuItem}</div>
        </div>

        <footer
          style={{
            position: 'fixed',
            bottom: 0,
            padding: '20px 0 20px 20px',
            fontSize: '12px',
            fontWeight: 'bold',
            zIndex: 11,
            width: isOpen ? '200px' : '50px',
            backgroundColor: '#00043C',
            borderRadius: '0 0 200px 0',
          }}
        >
          {`POWERED BY DEP v${version}`}
        </footer>
      </div>
      <main className="main" style={{ marginLeft: isOpen ? '240px' : '60px' }}>
        <div className="topbar">
          <div className="toggle">
            {isOpen ? (
              <BsTextIndentRight onClick={toggleIcon} style={{ fontWeight: '600' }} />
            ) : (
              <BsTextIndentLeft onClick={toggleIcon} style={{ fontWeight: '600' }} />
            )}
          </div>
          <h1>{(processType ?? 'Generic') === 'Generic' ? MAIN.xperience360 : processType}</h1>

          <div className="avatar">
            {title === 'chatGptQuery' && (
              <Button
                size="small"
                type="submit"
                variant="contained"
                sx={{
                  marginRight: '8px',
                  backgroundColor: '#00043C',
                  '&:hover': { backgroundColor: '#00043C' },
                  color: '#ffffff',
                }}
                onClick={handleOpenAddNewConnectionModal}
              >
                New Connection
              </Button>
            )}

            <Tooltip title="Cloud">
              <div className="topbar-cloud-image">
                <Image height={18} src={AWS_CONFIG_TYPE ? AWS_LOGO : AZURE_LOGO} preview={false} />
              </div>
            </Tooltip>

            <Divider orientation="vertical" flexItem />
            <div style={{ margin: '0 8px 0 15px' }}>
              <Tag color="#87d068" style={{ padding: '0 10px 2px 10px', fontWeight: 'bold' }}>
                {JSON.parse(sessionStorage.getItem('full_name'))}
              </Tag>
            </div>

            <Divider orientation="vertical" flexItem />
            <div className="user-icon">
              <Box sx={{ flexGrow: 0 }}>
                <Tooltip title="Open settings">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar>
                      <FaUserCircle size={25} />
                    </Avatar>
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: '45px' }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {settings.map((setting) => (
                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                      <Typography textAlign="center" onClick={handleLogout}>
                        {setting}
                      </Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </div>
          </div>
        </div>
        <section style={{ padding: '20px' }}>
          <Outlet />
        </section>
        {openModal && <UploadModal openModal={openModal} handleCloseModal={handleCloseModal} />}
        {openConnectionModal && (
          <AddConnectionModal open={setOpenConnectionModal} close={handleCloseAddNewConnectionModal} />
        )}
      </main>
    </div>
  );
};

export default Sidebar;
